import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Col, Form, Input, Row } from 'reactstrap';
import { Container } from './style';
import FlexSelect from 'components/Inputs/FlexSelect';
import { Controller, useForm } from 'react-hook-form';
import { ChatConfigurationSignalingService } from './service';
import { toast } from 'react-toastify';
import { parseDataConfigurationSignalingToInput } from 'utils/fuctions/mapSignalingTouse';

function formatTime(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  const hoursStr = hours > 0 ? `${hours} hr` : '';
  const minutesStr = minutes > 0 ? `${minutes}m` : '';
  const secondsStr = remainingSeconds > 0 ? `${remainingSeconds}s` : '';

  return [hoursStr, minutesStr, secondsStr].filter(Boolean).join(', ');
}

const ConversationSignaling = () => {
  const [loading, setLoading] = useState(true);
  const { setValue, control, watch, handleSubmit } = useForm();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  useEffect(() => {
    setLoading(true);
    ChatConfigurationSignalingService.get()
      .then((response) => {
        const dataToInput = parseDataConfigurationSignalingToInput(response);
        Object.keys(dataToInput).forEach((key) => {
          setValue(key, dataToInput[key]);
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const onSubmit = (data) => {
    setLoading(true);
    ChatConfigurationSignalingService.update(data)
      .then(() => {
        toast.success('Configuração salva com sucesso');
      })
      .catch(() => {
        toast.error('Erro ao salvar configuração');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Container color={systemConfiguration.primary_color}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col md="12"></Col>
            <strong className="ml-2">Interação do agente</strong>
          </Row>
          <Row className="mb-2">
            <Col md="4">
              <label>Tempo em segundos:</label>
              <Controller
                as={<Input type="number" />}
                control={control}
                name="time_agent_1"
              />
            </Col>
            <Col md="4">
              <label>Exibir</label>
              <Controller
                render={(props) => {
                  return (
                    <FlexSelect
                      dataOptions={[
                        {
                          label: 'Atenção',
                          value: 'warning'
                        },
                        {
                          label: 'Critico',
                          value: 'critical'
                        }
                      ]}
                      isMulti={false}
                      defaultValue={'warning'}
                      value={props.value}
                      valueController={setValue}
                      placeholder="Selecione uma ação"
                      isClearable={true}
                      closeMenuOnSelect={true}
                      fieldName="action_agent_1"
                      labelName="label"
                      valueName="value"
                    />
                  );
                }}
                control={control}
                name="action_agent_1"
              />
            </Col>
            <Col md="4">
              <label className="mt-4">
                Tempo: {formatTime(watch('time_agent_1'))}
              </label>
            </Col>
          </Row>
          <Row className="mb-5 ">
            <Col md="4">
              <Controller
                as={<Input type="number" />}
                control={control}
                name="time_agent_2"
              />
            </Col>
            <Col md="4">
              <Controller
                render={(props) => {
                  return (
                    <FlexSelect
                      dataOptions={[
                        {
                          label: 'Atenção',
                          value: 'warning'
                        },
                        {
                          label: 'Critico',
                          value: 'critical'
                        }
                      ]}
                      isMulti={false}
                      valueController={setValue}
                      defaultValue={'warning'}
                      value={props.value}
                      placeholder="Selecione uma ação"
                      isClearable={true}
                      closeMenuOnSelect={true}
                      fieldName="action_agent_2"
                      labelName="label"
                      valueName="value"
                    />
                  );
                }}
                control={control}
                name="action_agent_2"
              />
            </Col>
            <Col md="4">
              <label className="">
                Tempo: {formatTime(watch('time_agent_2'))}
              </label>
            </Col>
          </Row>
          <hr />

          <Row>
            <Col md="12"></Col>
            <strong className="ml-2">Interação do cliente</strong>
          </Row>
          <Row className="mb-2">
            <Col md="4">
              <label>Tempo em segundos:</label>
              <Controller
                as={<Input type="number" />}
                control={control}
                name="time_customer_1"
              />
            </Col>
            <Col md="4">
              <label>Exibir</label>
              <Controller
                render={(props) => {
                  return (
                    <FlexSelect
                      dataOptions={[
                        {
                          label: 'Atenção',
                          value: 'warning'
                        },
                        {
                          label: 'Critico',
                          value: 'critical'
                        }
                      ]}
                      isMulti={false}
                      defaultValue={'warning'}
                      value={props.value}
                      valueController={setValue}
                      placeholder="Selecione uma ação"
                      isClearable={true}
                      closeMenuOnSelect={true}
                      fieldName="action_customer_1"
                      labelName="label"
                      valueName="value"
                    />
                  );
                }}
                control={control}
                name="action_customer_1"
              />
            </Col>
            <Col md="4">
              <label className="mt-4">
                Tempo: {formatTime(watch('time_customer_1'))}
              </label>
            </Col>
          </Row>
          <Row className="mb-5 ">
            <Col md="4">
              <Controller
                as={<Input type="number" />}
                control={control}
                name="time_customer_2"
              />
            </Col>
            <Col md="4">
              <Controller
                render={(props) => {
                  return (
                    <FlexSelect
                      dataOptions={[
                        {
                          label: 'Atenção',
                          value: 'warning'
                        },
                        {
                          label: 'Critico',
                          value: 'critical'
                        }
                      ]}
                      isMulti={false}
                      defaultValue={'warning'}
                      valueController={setValue}
                      value={props.value}
                      placeholder="Selecione uma ação"
                      isClearable={true}
                      closeMenuOnSelect={true}
                      fieldName="action_customer_2"
                      labelName="label"
                      valueName="value"
                    />
                  );
                }}
                control={control}
                name="action_customer_2"
              />
            </Col>
            <Col md="4">
              <label className="">
                Tempo: {formatTime(watch('time_customer_2'))}
              </label>
            </Col>
          </Row>

          <Row>
            <Col md="2">
              <Button disabled={loading} color="success">
                Salvar
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </>
  );
};

export { ConversationSignaling };
